import { jsx as c } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        d: "M8 1.488a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm5 6.5c0 .488-.07.96-.201 1.406a13.51 13.51 0 0 0-1.816-.525 16.737 16.737 0 0 0-.03-2.045c.785-.169 1.397-.368 1.761-.5A4.98 4.98 0 0 1 13 7.987Zm-10 0c0-.574.098-1.125.276-1.639.359.127.969.321 1.755.486a17.11 17.11 0 0 0-.022 2.021c-.84.178-1.476.387-1.816.511A4.983 4.983 0 0 1 3 7.988Zm3.487.054c0-.332.012-.658.032-.973a13.587 13.587 0 0 0 2.948-.003 14.482 14.482 0 0 1 .025 1.557A13.603 13.603 0 0 0 6.5 8.62c-.008-.189-.012-.381-.012-.576Zm5.508-3.058c-.297.1-.715.226-1.223.342a17.869 17.869 0 0 0-.375-1.725c.626.344 1.17.817 1.598 1.383ZM8.653 3.03c.178.516.45 1.415.637 2.546a11.952 11.952 0 0 1-2.606.002 16.61 16.61 0 0 1 .598-2.538 5.006 5.006 0 0 1 1.371-.01Zm-3.105.601a18.365 18.365 0 0 0-.347 1.703 12.788 12.788 0 0 1-1.211-.329 5.037 5.037 0 0 1 1.558-1.374Zm-1.723 7.104c.284-.098.744-.242 1.329-.373.106.75.25 1.421.395 1.982a5.033 5.033 0 0 1-1.724-1.609Zm3.464 2.202c-.199-.601-.483-1.599-.654-2.824a12.088 12.088 0 0 1 2.73.005 16.841 16.841 0 0 1-.613 2.813 5.042 5.042 0 0 1-1.464.005h.001Zm3.19-.608c.135-.553.269-1.213.367-1.952.576.134 1.03.28 1.314.381a5.036 5.036 0 0 1-1.681 1.57Z"
      }
    )
  }
);
export {
  o as GlobeAddress
};
